export enum MappingSourceType {
  product = "product",
  ingredient = "ingredient",
  simulation = "simulation"
}

export enum MappingType {
  product = 1,
  ingredient = 2,
  simulation = 3
}
